import { httpRequest } from '../utils';

export const getCollaborators = async (token) => httpRequest('/api/brokers/collaborators', 'get', null, { Authorization: `Bearer ${token}` });

export const addCollaborator = async (token, collaborator) => httpRequest('/api/brokers/collaborator', 'post', collaborator, { Authorization: `Bearer ${token}` });

export const removeCollaborator = async (token, id) => httpRequest(`/api/brokers/collaborators/${id}`, 'delete', null, { Authorization: `Bearer ${token}` });

export const alertCollaborator = async (token, id, alert) => httpRequest(`/api/brokers/collaborators/${id}/alert/${alert}`, 'post', null, { Authorization: `Bearer ${token}` });
